module.exports = __webpack_public_path__ + "img/hetongku.75e64802.png";